import { useSelector } from 'react-redux';
import useUpdateSelectedPrograms from '../actions/useUpdateSelectedPrograms';

export default function useSelectedPrograms() {
  return {
    updateSelectedPrograms: useUpdateSelectedPrograms(),
    selectedPrograms: useSelector(state => state.layout.selectedPrograms)
  };
}
